module.exports = __webpack_public_path__ + "img/ror-stencil.3a347625.svg";